import ninegrid from "../index.js";
import { ngEditableEx } from "./_ngCell.js";

class ngInputText extends ngEditableEx
{
	#target;
	#type;
	#maxbyte;
	#min;
	#max;
	#scale;
	
	constructor () {
		super();

		this.applyBaseStyle();
		
		this.#type		= this.getAttribute("type") || "text";
		this.#maxbyte	= this.getAttribute("maxbyte");
		this.#min		= this.getAttribute("min");
		this.#max		= this.getAttribute("max");
		this.#scale		= this.getAttribute("scale");
		
		if (!["text","number"].includes(this.#type)) throw `invalid type : ${this.#type}`;
	}
	
	connectedCallback() {
		
		var attr = [];
		for (var i = 0; i < this.attributes.length; i++) {
			if (["type","maxlength","maxbyte","min","max","step","scale","text-align"].includes(this.attributes[i].name)) attr.push(`${this.attributes[i].name}="${this.attributes[i].value}"`);
		}
		 
		this.shadowRoot.innerHTML = `
			<input type="text"
				${attr.join(" ")}
				ondragstart="return false;" 
			>
		`;
		
		super.connectedCallback();

		this.#target = this.shadowRoot.querySelector("input");

		this.#target.addEventListener("keydown", this.#onKeyDown);
		
		this.#target.addEventListener("compositionstart",  e => {
			if (e.target.selectionStart == e.target.selectionEnd) {
				if (this.#maxbyte) {

					if (ninegrid.getByteLength(e.target.value) >= Number(this.#maxbyte)) {

						e.target.value = ninegrid.cut(e.target.value, Number(this.#maxbyte));
						
						this.value = e.target.value;
					}
				}
			}
		});
		
		this.#target.addEventListener("compositionupdate", e => {
			if (this.#type == "number") {
				e.target.value = e.target.value.replace(e.data, "");
			}
		});
		this.#target.addEventListener("compositionend", e => {
			
		});
		
		/**
		 * jquery는 e.isComposing 미지원
		 * cellManager로 옮겨야할듯...
		 */
		this.#target.addEventListener("keydown", e => {
			if (e.isComposing || e.keyCode === 229) return;
			
			if (["Enter","Escape"].includes(e.code)) {
				this.owner.cell.currentCell = this.cell;
			}
			else if (["Tab","PageUp","PageDown","ArrowUp","ArrowDown"].includes(e.code)) {
				this.owner.cell.currentCell = this.cell;
				this.owner.cell.moveCell(e);
			}
		});
	};
	
	
	dataRefresh = (v) => {
		this.#target.value = this.value;

		
		ninegrid.j.querySelectorAll(this.#target).removeClass("invalid");
		
		if (this.#type == "number") {

			if (isNaN(this.value) ||
				this.#max && Number(this.#target.value) > Number(this.#max) ||
				this.#min && Number(this.#target.value) < Number(this.#min)
			) {
				ninegrid.j.querySelectorAll(this.#target).addClass("invalid");
			}
			else if (this.#scale) {
				if (this.#target.value.indexOf('.') >= 0 && this.#target.value.substring(this.#target.value.indexOf('.')+1).length > Number(this.#scale) ) {
					ninegrid.j.querySelectorAll(this.#target).addClass("invalid");
				}
			}
		}
		

		if (this.#maxbyte && ninegrid.getByteLength(this.value) > Number(this.#maxbyte)) {
			ninegrid.j.querySelectorAll(this.#target).addClass("invalid");
		}
		
		if (!v) this.reset();
	};
	
	#onKeyDown = e => {
		
		
		/**
		if (["Enter","Escape"].includes(e.code)) {
			
			e.preventDefault();
			
			$(this.cell).focus();
			this.owner.cell.currentCell = this.cell;
		} */

		if (["Escape","Enter","Tab","Home","End","ArrowLeft","ArrowRight","PageUp","PageDown","Backspace","Delete"].includes(e.code)) return;
		
		if (this.#type == "number") {

			let validKey = [];
			if (this.#scale && Number(this.#scale) > 0) validKey.push(".");
			if (this.#min && Number(this.#min) >= 0)  validKey.push("-");
			
			if (!(e.keyCode >= 48 && e.keyCode <= 57 || e.keyCode >= 96 && e.keyCode <= 105) && !validKey.includes(e.key)) e.preventDefault();
			
			if (this.#scale) {
				if ((e.keyCode >= 48 && e.keyCode <= 57 || e.keyCode >= 96 && e.keyCode <= 105) && e.target.selectionStart == e.target.selectionEnd) {
					var s = e.target.value;
					var idx = s.indexOf(".");
					
					if (idx >= 0) {
						var s = s.substr(idx + 1, s.length);
						if (s.length >= Number(this.#scale)) e.preventDefault();
					}
				}
			}
		}
		

		if (this.#maxbyte && ninegrid.getByteLength(e.target.value) >= Number(this.#maxbyte) && e.target.selectionStart == e.target.selectionEnd) e.preventDefault();
	}
}

if (!customElements.get('ng-input')) {
	customElements.define("ng-input", ngInputText);
}
